import React from 'react';
import { Building2 } from 'lucide-react';
import SwipeToast from './SwipeToast';

/**
 * Notificação no inbox que sugere ao user (com plano Business sem empresa)
 * criar a Conta Empresa para convidar vendedores.
 *
 * Visibilidade gerenciada pelo hook `useCreateCompanyNotification` —
 * só aparece quando tier contém "business" E user não está em empresa
 * E não foi dismissed em localStorage.
 */
const CreateCompanyNotification = ({ isOpen, onCreate, onDismiss }) => (
  <SwipeToast
    isOpen={isOpen}
    icon={<Building2 size={20} />}
    title="Crie sua empresa"
    description="Adicione vendedores e compartilhe seu agente IA. O primeiro vendedor não custa nada a mais."
    ctaLabel="Criar empresa"
    onCta={onCreate}
    onDismiss={onDismiss}
  />
);

export default CreateCompanyNotification;
